'use strict';

document.addEventListener('DOMContentLoaded', () => {
    const parent = document.querySelectorAll('.cm-pd-scrolling-text__content-text p.cm-p');
    if (parent) {
        parent.forEach((p, index) => {
            if (index > 0) {
                p.setAttribute('aria-hidden', 'true');

                const links = p.querySelectorAll('a');
                links.forEach(link => {
                    link.setAttribute('tabindex', '-1');
                    link.setAttribute('aria-hidden', 'true');
                });
            }
        });
    }
});
